import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const SettingsIcon = forwardRef<SVGSVGElement, IconProps>(function SettingsIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.49207 2.00855C3.62808 2.05663 3.77634 1.97211 3.80321 1.82777C4.257 -0.609257 7.74301 -0.609257 8.19679 1.82777C8.22366 1.97211 8.37192 2.05663 8.50793 2.00855C10.847 1.18176 12.5809 4.21 10.7053 5.81886C10.5945 5.91391 10.5945 6.08609 10.7053 6.18114C12.5809 7.79 10.847 10.8182 8.50793 9.99145C8.37192 9.94337 8.22366 10.0279 8.19679 10.1722C7.74301 12.6093 4.257 12.6093 3.80321 10.1722C3.77634 10.0279 3.62808 9.94337 3.49207 9.99145C1.153 10.8182 -0.580905 7.79 1.29471 6.18114C1.40551 6.08609 1.40551 5.91391 1.29471 5.81886C-0.580904 4.21 1.153 1.18176 3.49207 2.00855ZM7.21473 2.01101C6.96372 0.662997 5.03628 0.662997 4.78528 2.01101C4.64619 2.75795 3.87461 3.20428 3.15945 2.95149C1.86878 2.49528 0.905063 4.16772 1.94472 5.05952C2.52081 5.55367 2.52081 6.44633 1.94472 6.94048C0.905063 7.83228 1.86878 9.50472 3.15945 9.04851C3.87461 8.79572 4.64619 9.24205 4.78528 9.98899C5.03628 11.337 6.96372 11.337 7.21473 9.98899C7.35381 9.24205 8.12539 8.79572 8.84055 9.04851C10.1312 9.50472 11.0949 7.83228 10.0553 6.94048C9.47919 6.44633 9.47919 5.55367 10.0553 5.05952C11.0949 4.16772 10.1312 2.49528 8.84055 2.95149C8.12539 3.20428 7.35381 2.75795 7.21473 2.01101Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7C5.44828 7 5.00103 6.55228 5.00103 6C5.00103 5.44772 5.44828 5 6 5C6.55172 5 6.99898 5.44772 6.99898 6C6.99898 6.55228 6.55172 7 6 7ZM6 8C4.89656 8 4.00205 7.10457 4.00205 6C4.00205 4.89543 4.89656 4 6 4C7.10344 4 7.99795 4.89543 7.99795 6C7.99795 7.10457 7.10344 8 6 8Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
